import React from 'react'
import { LazyImage } from '@offerzen/pinata-shame'

import Container from '../Container'

import styles from '../Navbar/styles'

const BareBonesNavbar = () => {
  return (
    <nav className={styles.wrapper}>
      <Container className={styles.container}>
        <a href="/" className={styles.logo}>
          <LazyImage className={styles.logoImage} loader={() => import('../../../assets/offerzen-logo.svg')} />
        </a>
      </Container>
    </nav>
  )
}

export default BareBonesNavbar
